import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';

import { SN_DRAWER_DATA } from 'libs/ui/drawer/src/lib/providers';

import { FsLvtCamera } from '../../models/lvt-camera';
import { FsLvtSounds } from '../../models/lvt-sounds';
import { FsLvtLights } from '../../models/lvt-lights';
import { SnLvtService } from '../../services/lvt.service';
import { FsLvtToken } from '../../models/lvt-token';

@Component({
  templateUrl: './lvt-drawer.component.html',
  styleUrls: ['./lvt-drawer.component.scss'],
})
export class LvtDrawerComponent implements OnInit, OnDestroy {
  public soundSelect: any;
  public lightSelect: any;
  public readonly lvtCam: FsLvtCamera;
  public lvtCams: FsLvtCamera[] = [];
  public soundList: FsLvtSounds[] = [];
  public lightList: FsLvtLights[] = [];
  public headers: any;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(SN_DRAWER_DATA) public readonly data: any,
    private readonly _lvtService: SnLvtService,
    private readonly _cd: ChangeDetectorRef,
  ) {
    this.lvtCam = data.__drawerData__;
  }

  public ngOnInit(): void {
    this._lvtService
      .getLvtSounds(this.lvtCam.liveUnitId, this.lvtCam.accountName)
      .pipe(takeUntil(this._destroy$))
      .subscribe((value: FsLvtSounds[]) => {
        this.soundList = value;
      });
    this._lvtService
      .getLvtLights(this.lvtCam.liveUnitId, this.lvtCam.accountName)
      .pipe(takeUntil(this._destroy$))
      .subscribe((value: FsLvtLights[]) => {
        this.lightList = value;
      });
    this._lvtService
      .getToken(this.lvtCam.accountName)
      .pipe(takeUntil(this._destroy$))
      .subscribe((value: FsLvtToken) => {
        this.headers = {
          Authorization: `Bearer ${value.accessToken}`,
        };
        this._getLvtCams();
      });
  }

  public playSound(item: FsLvtSounds): void {
    this._lvtService
      .postLvtSounds(this.lvtCam.liveUnitId, this.lvtCam.accountName, item.id)
      .pipe(takeUntil(this._destroy$))
      .subscribe();
    setTimeout(() => {
      this.soundSelect = '';
      this._cd.detectChanges();
    }, 3000);
  }

  public playLight(item: FsLvtLights[]): void {
    const toggleOff: FsLvtLights[] = this.lightList.filter((x) => !item.includes(x));
    toggleOff.forEach((a) => {
      this.toggleLight(a, 'off');
    });
    item.forEach((b) => {
      this.toggleLight(b, 'on');
    });
  }

  public toggleLight(item: FsLvtLights, state: string): void {
    this._lvtService
      .postLvtLights(this.lvtCam.liveUnitId, this.lvtCam.accountName, item.id, { state })
      .pipe(takeUntil(this._destroy$))
      .subscribe();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public trackCam(index: Number, item: FsLvtCamera): string {
    return item.id;
  }

  private _getLvtCams(): void {
    this._lvtService
      .getLvtCams(this.lvtCam.liveUnitId)
      .pipe(takeUntil(this._destroy$))
      .subscribe((cams: FsLvtCamera[]) => {
        this.lvtCams = cams;
        this._cd.detectChanges();
      });
  }
}
